
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { __spreadArray, __read } from '../../../../../../tslib/tslib.es6.mjs.js';
import { dimensionValueTypes } from './dimensions.mjs.js';
import { testValueType } from './test.mjs.js';
import { color } from '../../../../../../style-value-types/dist/es/color/index.mjs.js';
import { complex } from '../../../../../../style-value-types/dist/es/complex/index.mjs.js';

/**
 * A list of all ValueTypes
 */
var valueTypes = __spreadArray(__spreadArray([], __read(dimensionValueTypes), false), [color, complex], false);
/**
 * Tests a value against the list of ValueTypes
 */
var findValueType = function (v) { return valueTypes.find(testValueType(v)); };

export { findValueType };
//# sourceMappingURL=find.mjs.js.map
